import { Base } from "@/components/Navigation/Buttons/CartButton/cartButton.base";
import { Content } from "@/components/Navigation/Buttons/CartButton/components/content/content";
import { useCartButtonContext } from "@/components/Navigation/Buttons/CartButton/context/cartButton.context";

export const CartButton = Object.assign(Base, {
    useContext: useCartButtonContext,
    Content: Content
});
